var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.28,7.35C15.6,3.05,13.91,0,12,0S8.44,3.05,7.72,7.35ZM7.38,12c0,1.11,0,2.13.14,3.1h9c.09-1,.14-2,.14-3.1s-.05-2.08-.14-3.1h-9C7.43,9.92,7.38,10.94,7.38,12ZM23.06,7.35A12,12,0,0,0,15.41.53a16.18,16.18,0,0,1,2.42,6.82ZM8.59.53A12,12,0,0,0,.94,7.35H6.17A16.18,16.18,0,0,1,8.59.53Zm15,8.37H18c.1,1,.2,2.08.2,3.1s-.1,2.08-.2,3.1h5.57A12.77,12.77,0,0,0,24,12,13.43,13.43,0,0,0,23.59,8.9ZM5.83,12c0-1,0-2.08.15-3.1H.41A13.43,13.43,0,0,0,0,12a12.77,12.77,0,0,0,.39,3.1H6C5.88,14.08,5.83,13.06,5.83,12Zm1.89,4.65C8.44,21,10.09,24,12,24s3.58-3,4.26-7.35Zm7.69,6.87a11.91,11.91,0,0,0,7.65-6.87H17.83A15.65,15.65,0,0,1,15.41,23.52ZM.94,16.65a11.91,11.91,0,0,0,7.65,6.87,16.17,16.17,0,0,1-2.42-6.87Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.a8573b43.svg";
export { ForwardRef as ReactComponent };